<template>
  <div>
    <v-card
      style="
        border-radius: 4px;
        padding-top: 10px;
        overflow-y: auto;
        display: flex;
        background-color: unset;
        height: unset !important;
      "
      class="mb-3"
      flat>
      <v-card
        flat
        style="
          width: 100%;
          height: 65px !important;
          background: var(--v-cardColor-base);
        "
        class="mb-2">
        <div
          style="
            display: flex;
            flex-direction: column;
            margin-top: 7px;
            height: 80%;
          ">
          <div style="font-weight: bold">Asset Expiry</div>
          <v-spacer />
          <input
            @change="update_time()"
            step="1"
            type="date"
            v-model="processed_datetime" />
        </div>
      </v-card>

      <v-btn
        title="Reset Asset Expiry to the current default"
        class="ml-3"
        variant="tonal"
        style="height: 65px !important; box-shadow: unset"
        @click="
          updated_expiry = undefined;
          processed_datetime = get_expire_time();
        ">
        <v-icon>mdi-refresh</v-icon>
      </v-btn>
    </v-card>
  </div>
</template>
<script setup>
import { deluge } from '../../../stores/deluge';
import { ref, onMounted } from 'vue';
const updated_expiry = ref(undefined);
const props = defineProps(['userEditObj']);
const processed_datetime = ref(0);

onMounted(() => {
  console.log(props.userEditObj.expire_datetime);
  updated_expiry.value = props.userEditObj.expire_datetime;
  processed_datetime.value = get_expire_time();
});
function get_expire_time() {
  if (!updated_expiry.value && deluge?.config?.asset_expire_time) {
    let dt = new Date(props.userEditObj.timestamp);
    dt = new Date(
      dt.getTime() + deluge?.config?.asset_expire_time * 86400 * 1000
    );
    return dt.toISOString().slice(0, 10);
  } else {
    let dt = new Date(props.userEditObj.expire_datetime);

    return dt.toISOString().slice(0, 10);
  }
}
function update_time() {
  updated_expiry.value = processed_datetime.value;
  props.userEditObj.expire_datetime = updated_expiry.value;
}
</script>
